import { render, staticRenderFns } from "./navIcn.vue?vue&type=template&id=60be1333&scoped=true&"
import script from "./navIcn.vue?vue&type=script&lang=js&"
export * from "./navIcn.vue?vue&type=script&lang=js&"
import style0 from "./navIcn.vue?vue&type=style&index=0&id=60be1333&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be1333",
  null
  
)

export default component.exports